import React, { useState, useEffect, useRef } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../../src/Config";
import PaginationView from "../../Component/PaginationView";

function CalibrationLogs({ isSidebarExpanded }) {
  const [logs, setLogs] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const { detector_id } = useParams();

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/calibration_sessions`, {
        headers: { Authorization: authKey },
        params: detector_id ? { calibration_schedule_id: detector_id } : {},
      });

      const logsData = response.data.calibration_sessions || [];
      setLogs(logsData);
      setTotalItems(logsData.length);
      setError("");
    } catch (err) {
      console.error("Error fetching cylinder logs:", err);
      setError("Failed to fetch logs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [detector_id, currentPage]);

  const handleBack = () => {
    navigate(-1);
  };

  const paginatedLogs = logs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "#4CAF50"; // green
      case "in progress":
        return "#2196F3"; // blue
      case "cancelled":
        return "#9E9E9E"; // grey
      case "failed":
        return "#F44336"; // red
      default:
        return "#000"; // default black
    }
  };

  const getPassFailColor = (value) => {
    switch (value?.toLowerCase()) {
      case "pass":
        return "#4CAF50";
      case "fail":
        return "#F44336";
      default:
        return "#9E9E9E";
    }
  };

  return (
    <div
      className={`main-container page-content${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div
        className={`data-lists-content-container page-contents ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <div className="data-list-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      marginRight: "8px",
                    }}
                    onClick={handleBack}
                  />
                </Tooltip>
                CALIBRATION SESSIONS
              </div>
            </div>
          </div>

          <div className="data-list-body">
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <p style={{ textAlign: "center" }}>Loading...</p>
                ) : error ? (
                  <p style={{ textAlign: "center", color: "red" }}>{error}</p>
                ) : (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th>SR. NO.</th>
                        <th>PASS/FAIL</th>
                        <th>STATUS</th>
                        <th>REMARKS</th>
                        <th>PERFORMED BY</th>
                        <th>PERFORMED AT</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {paginatedLogs.length === 0 ? (
                        <tr>
                          <td colSpan="5" style={{ textAlign: "center" }}>
                            No Sessions found.
                          </td>
                        </tr>
                      ) : (
                        paginatedLogs.map((log, index) => (
                          <tr key={index} className="hoverable-row">
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>
                              <span
                                style={{
                                  color: getPassFailColor(log.pass_fail),
                                  fontWeight: "bold",
                                  textTransform: "uppercase",
                                }}
                              >
                                {log.pass_fail || "NA"}
                              </span>
                            </td>
                            <td>
                              <span
                                style={{
                                  color: getStatusColor(log.status),
                                  fontWeight: "bold",
                                  textTransform: "capitalize",
                                }}
                              >
                                {log.status || "NA"}
                              </span>
                            </td>
                            <td>{log.notes || "NA"}</td>
                            <td>{log.performed_by_name || "NA"}</td>
                            <td>
                              {log.performed_at
                                ? new Date(log.performed_at)
                                    .toUTCString()
                                    .split("GMT")[0]
                                    .trim() + " IST"
                                : "NA"}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}

                {/* Uncomment if pagination is needed */}
                {/* <PaginationView
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalibrationLogs;
